import React, { useState } from "react";
import css from "./CompanyTaxAddress";

import PropTypes from "prop-types";

import { connect } from "react-redux";

import TextInput from "Components/Inputs/Text";
import Button from "Components/Button";
import { getIsRequesting } from "../../../../../Selectors/app";
import { displayValidationError, sendCompanyTaxAddressUpdate } from "./actions";
import { validateFormInputs } from "./validateFormInputs";

const CompanyTaxAddress = ({
	isUpdatingCompanyTaxAddress,
	sendCompanyTaxAddressUpdate,
	displayValidationError,
	data,
}) => {
	const [formData, setFormData] = useState({
		companyCode: data.get("company_code", ""),
		addressLine1: data.get("address_line_1", ""),
		addressLine2: data.get("address_line_2", ""),
		zipCode: data.get("zip", ""),
		hasTaxExclusion: data.get("has_tax_exclusion", false),
	});

	const handleInputChange = (name, value) => {
		setFormData({
			...formData,
			[name]: value,
		});
	};

	const handleSubmit = () => {
		const validation = validateFormInputs(formData);
		if (!validation.isValid) {
			displayValidationError(validation.message);
			return;
		}

		const { companyCode, addressLine1, addressLine2, zipCode, hasTaxExclusion } = formData;
		sendCompanyTaxAddressUpdate({ companyCode, addressLine1, addressLine2, zipCode, hasTaxExclusion });
	};

	return (
		<div>
			<div className={css.CompanyTaxAddress}>
				<div className={css.checkboxContainer}>
					<input
						type="checkbox"
						id="salesTaxExempt"
						checked={formData.hasTaxExclusion}
						onChange={() => handleInputChange("hasTaxExclusion", !formData.hasTaxExclusion)}
					/>
					<label className={css.checkboxLabel} htmlFor="salesTaxExempt">
						Does not pay US sales taxes
					</label>
				</div>
			</div>

			<div className={css.CompanyTaxAddress}>
				<div className={css.label}>Company Code</div>

				<div className={css.inputsContainer}>
					<div className={css.input}>
						<TextInput
							name="companyCode"
							value={formData.companyCode}
							onChange={(val) => handleInputChange("companyCode", val)}
						/>
					</div>
				</div>
			</div>

			<div className={css.CompanyTaxAddress}>
				<div className={css.label}>Address Line 1</div>

				<div className={css.inputsContainer}>
					<div className={css.input}>
						<TextInput
							name="addressLine1"
							value={formData.addressLine1}
							onChange={(val) => handleInputChange("addressLine1", val)}
						/>
					</div>
				</div>
			</div>

			<div className={css.CompanyTaxAddress}>
				<div className={css.label}>Address Line 2</div>

				<div className={css.inputsContainer}>
					<div className={css.input}>
						<TextInput
							name="addressLine2"
							value={formData.addressLine2}
							onChange={(val) => handleInputChange("addressLine2", val)}
						/>
					</div>
				</div>
			</div>

			<div className={css.CompanyTaxAddress}>
				<div className={css.label}>Zip Code</div>

				<div className={css.inputsContainer}>
					<div className={css.input}>
						<TextInput
							name="zipCode"
							value={formData.zipCode}
							onChange={(val) => handleInputChange("zipCode", val)}
						/>
					</div>
				</div>
			</div>

			<div className={css.CompanyTaxAddress}>
				<div className={css.buttonContainer}>
					<Button isRequesting={isUpdatingCompanyTaxAddress} onClick={handleSubmit}>
						Save
					</Button>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	isUpdatingCompanyTaxAddress: getIsRequesting(state, "COMPANIES:TAX_ADDRESS.UPDATE"),
});

const mapDispatchToProps = (dispatch) => ({
	sendCompanyTaxAddressUpdate: ({ companyCode, addressLine1, addressLine2, zipCode, hasTaxExclusion }) => {
		dispatch(sendCompanyTaxAddressUpdate({ companyCode, addressLine1, addressLine2, zipCode, hasTaxExclusion }));
	},
	displayValidationError: (message) => {
		dispatch(displayValidationError(message));
	},
});

CompanyTaxAddress.propTypes = {
	isUpdatingCompanyTaxAddress: PropTypes.bool.isRequired,
	sendCompanyTaxAddressUpdate: PropTypes.func.isRequired,
	displayValidationError: PropTypes.func.isRequired,
	data: PropTypes.object.isRequired,
};

CompanyTaxAddress.defaultProps = {
	data: new Map(),
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyTaxAddress);
